export const settingsNavPathV3 = {
  content: {
    pages: "/settings/pages" as const,
    posts: "/settings/posts" as const,
    spaces: "/settings/spaces" as const,
    topics: "/settings/topics" as const,
    topics_new: "/settings/topics/new",
    topics_edit: (topicId: string) => `/settings/topics/${topicId}/edit`,
    moderation: "/settings/moderation",
    edit_moderation: "/settings/moderation/edit",
    posts_bulk_actions: "/settings/posts/bulk_actions",
    live_streams: "/settings/live_streams",
    files: "/settings/files",
    theme: "/settings/theme",
  },
  plus: {
    index: "/settings/plus",
    app_settings: "/settings/plus/app-settings",
    billing: "/settings/plus/billing",
    push_notifications: "/settings/plus/push-notifications",
    push_notifications_edit: "/settings/plus/push-notifications/:id/edit",
    push_notifications_view: "/settings/plus/push-notifications/:id/view",
    push_notifications_view_analytics:
      "/settings/plus/push-notifications/:id/view/analytics",
    landing_page: "/settings/branded_apps_builder_landing_page",
    lite: "/settings/plus/lite",
    invoices: "/settings/plus/invoices",
  },
  email: {
    overview: "/settings/emails",
    broadcast: "/settings/emails/broadcast",
    broadcast_edit: "/settings/emails/broadcast/:id",
    broadcast_view: "/settings/emails/broadcast/:id/view",
    new_broadcast: "/settings/emails/broadcast/new",
    settings: "/settings/emails/settings",
    forms: "/settings/emails/forms",
    templates: "/settings/emails/templates",
  },
  newsletter: {
    overview: "/settings/newsletter",
    posts: "/settings/newsletter/posts",
  },
  members: {
    manage: "/settings/audience/manage",
    invite: "/settings/members/invite/details",
    invite_access: "/settings/members/invite/access",
    invite_emails: "/settings/members/invite/emails",
    invite_paywalls: "/settings/members/invite/paywalls",
    bulk_logs: "/settings/members/bulk_import_tasks",
    onboarding: "/settings/members/onboarding",
    onboarding_access: "/settings/members/onboarding/access",
    onboarding_preview: "/settings/members/onboarding/preview",
    onboarding_workflows: "/settings/members/onboarding/workflows",
    import_contacts: "/settings/contacts/import",
    gamification: "/settings/gamification",
    invitation_links: "/settings/invitation_links",
    new_invitation_link: "/settings/invitation_links/new",
    new_invitation_link_details: "/settings/invitation_links/new/details",
    new_invitation_link_access: "/settings/invitation_links/new/access",
    new_invitation_link_paywalls: "/settings/invitation_links/new/paywalls",
    edit_invitation_link_details: "/settings/invitation_links/:id/edit/details",
    edit_invitation_link_access: "/settings/invitation_links/:id/edit/access",
    edit_invitation_link_paywalls:
      "/settings/invitation_links/:id/edit/paywalls",
    edit_invitation_link: "/settings/invitation_links/:id/edit",
    profile_fields: "/settings/profile_fields",
    activity_logs: "/settings/members/activity_logs",
    access_groups: "/settings/access_groups",
    edit_access_group: {
      path: "/settings/access_groups/:id/edit",
      to: (id: string | number) => `/settings/access_groups/${id}/edit`,
    },
    segments: "/settings/segments",
    member_tags: "/settings/member_tags",
  },
  paywalls: {
    index: "/settings/paywalls" as const,
    new_paywall: {
      path: "/settings/paywalls/new/:tab?",
      to: (tab?: string) =>
        tab ? `/settings/paywalls/new/${tab}` : "/settings/paywalls/new",
    },
    edit_paywall: {
      path: "/settings/paywalls/:id/edit/:tab?",
      to: (paywallId: string | number, tab?: string) =>
        tab
          ? `/settings/paywalls/${paywallId}/edit/${tab}`
          : `/settings/paywalls/${paywallId}/edit`,
    },
    new_paywall_upsell_customization: {
      path: "/settings/paywalls/new/upsell/customization",
      to: () => "/settings/paywalls/new/upsell/customization",
    },
    edit_paywall_upsell_customization: {
      path: "/settings/paywalls/:id/edit/upsell/customization",
      to: (paywallId: string | number) =>
        `/settings/paywalls/${paywallId}/edit/upsell/customization`,
    },
    new_paywall_checkout_customization: {
      path: "/settings/paywalls/new/checkout/customization",
      to: () => "/settings/paywalls/new/checkout/customization",
    },
    edit_paywall_checkout_customization: {
      path: "/settings/paywalls/:id/edit/checkout/customization",
      to: (paywallId: string | number) =>
        `/settings/paywalls/${paywallId}/edit/checkout/customization`,
    },
    coupons: "/settings/coupons",
    new_coupon: {
      path: "/settings/coupons/new/:tab?",
      to: (tab?: string) =>
        tab ? `/settings/coupons/new/${tab}` : "/settings/coupons/new",
    },
    edit_coupon: {
      path: "/settings/coupons/:id/edit/:tab?",
      to: (couponId: string | number, tab?: string) =>
        tab
          ? `/settings/coupons/${couponId}/edit/${tab}`
          : `/settings/coupons/${couponId}/edit`,
    },
    subscription_groups: "/settings/paywall_groups",
    transactions: "/settings/paywall_charges",
    subscriptions: "/settings/paywall_subscriptions",
    taxes: "/settings/paywall_tax_settings",
    bulk_logs: "/settings/paywall_bulk_logs",
    payment_settings: "/settings/paywall_payment_settings",
  },
  affiliates: {
    directory: "/settings/affiliates_directory",
    commissions: "/settings/affiliates_commissions",
    settings: "/settings/affiliates_settings",
  },
  plans: {
    general: "/settings/plans",
    billing: "/settings/billing",
    brandedApps: "/settings/branded_apps",
    cancel: "/settings/cancel-plan",
    invoices: "/settings/invoices",
    payment_details: "/settings/payment_details",
  },
  developers: {
    overview: "/settings/developers",
    api: "/settings/api",
    new_api: "/settings/api/new",
  },
  // [AfterAnalyticsV4] TODO: rename this group to just analytics
  analytics_v2: {
    index: "/settings/analytics",
    members: "/settings/analytics/members",
    website: "/settings/analytics/website",
    videos: "/settings/analytics/videos",
    post_comments: "/settings/analytics/post_comments",
    messages: "/settings/analytics/messages",
    spaces: "/settings/analytics/spaces",
    events: "/settings/analytics/events",
    courses: "/settings/analytics/courses",
    devices: "/settings/analytics/devices",
    payments: "/settings/analytics/payments",
    ai_agents: "/settings/analytics/ai_agents",
    reviews: "/settings/analytics/reviews",
  },
  community_inbox: {
    index: "/settings/ai-inbox",
  },
  unified_inbox: {
    index: "/settings/inbox",
    ai: "/settings/inbox/ai",
    ai_conversation: "/settings/inbox/ai/conversations/:id",
    chat_threads: "/settings/inbox/chat-threads",
    chat_threads_thread: "/settings/inbox/chat-threads/:id",
    connection_requests: "/settings/inbox/connection-requests",
    connection_requests_item: "/settings/inbox/connection-requests/:id",
    course_comments: "/settings/inbox/course-comments",
    course_comments_thread: "/settings/inbox/course-comments/:chatRoomUuid",
    human_support: "/settings/inbox/human-support",
    human_support_conversation:
      "/settings/inbox/human-support/conversations/:id",
    moderation: "/settings/inbox/moderation",
    moderation_item: "/settings/inbox/moderation/:id",
    notifications: "/settings/inbox/notifications",
    priority_inbox: "/settings/inbox/priority",
  },
  community_bot: {
    knowledge: "/settings/ai-agents/knowledge",
    agents: "/settings/ai-agents/agents",
  },
} as const;

export type SettingsNavPathV3 = keyof typeof settingsNavPathV3;

export const isSettingsNavPathV3 = (path: unknown): path is SettingsNavPathV3 =>
  typeof path === "string" && path in settingsNavPathV3;
